import { IAttribute } from './../../base/annotation';
import { ParquetDataset } from 'shell-models-lib';
import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { FormatTypeCopySource } from './format-type.copysource';

@Metamodel.model({
    name: 'ParquetSource',
    display: [],
    tags: { datasetModel : [Metamodel.modelFor(ParquetDataset)]}
})
export class ParquetCopySource extends FormatTypeCopySource {
    public static readonly READER_WILDCARDPATH: IAttribute;
    @Metamodel.attribute({
        templatable: true,
        association: 'READER_WILDCARDPATH',
        display: stringResources.ModelName_WildcardPath
    })
    public readerWildcardPath?: string;
}
